import { SpsLogger } from '@lib/utils';
import { ALLOWED_HTML_TAGS } from '@core/config';
import { HyphenatePipe } from '../../../../pipes/hyphenate/hyphenate.pipe';

export class HtmlHelper {
  private static get parser(): DOMParser {
    return (this._parser ||= new DOMParser());
  }

  private static _parser: DOMParser;
  private static allowedControlCharsMapping = {
    '\n': '<br/>',
    '\r': '<br/>',
  };

  static addPdfTargets(html: string): string {
    try {
      const doc = HtmlHelper.parser.parseFromString(html, 'text/html');
      const links = Array.from(doc.documentElement.querySelectorAll('a'))?.filter(a => a.href.toLowerCase().endsWith('.pdf'));

      if (!links.length) {
        return html;
      }

      links.forEach(link => (link.target = '_blank'));

      return doc.body.innerHTML;
    } catch (e) {
      SpsLogger.warn('[HttpHelper]: Error trying to add targets to pdf links', e);
      return html;
    }
  }

  static sanitizeHtml(html: string): string {
    const doc = HtmlHelper.parser.parseFromString(html, 'text/html');

    try {
      doc.body.querySelectorAll('*').forEach(node => {
        node.innerHTML = this.sanitizeControlChars(node.innerHTML);

        if (ALLOWED_HTML_TAGS.includes(node.tagName.toLowerCase())) {
          return;
        }

        const replacement = doc.createElement('span');
        replacement.innerHTML = node.innerHTML;
        replacement.classList.add('replacement');

        node.parentNode?.replaceChild(replacement, node);
      });

      return doc.body.innerHTML;
    } catch (e) {
      SpsLogger.warn('[HttpHelper]: Error trying to sanitize html', e);
      return html;
    }
  }

  static sanitizeControlChars(html: string = null, strip = false, hyphenate: boolean = false): string | null {
    if (!html) {
      return null;
    }

    Object.keys(this.allowedControlCharsMapping).forEach(controlChar => {
      if (!html.includes(controlChar)) {
        return;
      }

      const regex = new RegExp(controlChar, 'ig');
      const replacement = strip ? '' : this.allowedControlCharsMapping[controlChar];

      html = html.replace(regex, replacement);
    });

    return hyphenate ? HyphenatePipe.transform(html) : html;
  }
}
